function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Virdee");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-17.3%",
  y: "-17.3%",
  width: "134.6%",
  height: "134.6%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.662041084 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("polygon", {
  id: "path-2",
  points: "3.59739413e-05 0.185139889 92.567786 0.185139889 92.567786 42.2894513 3.59739413e-05 42.2894513"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Designs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Virdee-Sign-In---Desktop-Copy-8",
  transform: "translate(-643.000000, -135.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy",
  filter: "url(#filter-1)",
  transform: "translate(653.000000, 143.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  fill: "#171717",
  stroke: "#5E6272",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("g", {
  id: "face"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.1270398,2.00089654 C107.491867,2.03914755 112.092267,3.30130017 116.709488,5.77061695 C121.244684,8.19606666 124.803933,11.7553155 127.229383,16.2905122 C129.737283,20.9798772 131,25.6518913 131,38.458278 L131,38.458278 L131,94.541722 C131,107.348109 129.737283,112.020123 127.229383,116.709488 C124.803933,121.244684 121.244684,124.803933 116.709488,127.229383 C112.020123,129.737283 107.348109,131 94.541722,131 L94.541722,131 L38.458278,131 C25.6518913,131 20.9798772,129.737283 16.2905122,127.229383 C11.7553155,124.803933 8.19606666,121.244684 5.77061695,116.709488 C3.3022183,112.093984 2.04006222,107.495676 2.00092996,95.1348026 L2.00092996,95.1348026 L2.00089654,37.8729602 C2.03914755,25.508133 3.30130017,20.9077331 5.77061695,16.2905122 C8.19606666,11.7553155 11.7553155,8.19606666 16.2905122,5.77061695 C20.9060164,3.3022183 25.5043245,2.04006222 37.8651974,2.00092996 L37.8651974,2.00092996 Z",
  id: "Rectangle"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group-38-Copy",
  transform: "translate(20.000000, 35.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.126770, 0.069564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.9413496,0.185103799 C61.8914033,0.185103799 58.3022832,2.12672681 56.0186574,5.1228893 C55.6488453,5.60829505 38.2155136,32.1219151 38.2155136,32.1219151 C38.1644306,32.2034777 38.1133476,32.2832358 38.057588,32.3611895 C37.2460159,33.4936826 35.9297293,34.2378511 34.4335731,34.2378511 C33.7889201,34.2378511 33.1791618,34.0949361 32.6255228,33.8484438 C31.8923739,33.5221934 31.2675065,33.0032243 30.8052414,32.3561369 C30.7523597,32.2821531 30.7037949,32.2063649 30.6552301,32.1287721 L16.0059217,9.91306814 C17.5358934,9.01840579 19.26624,8.43411441 21.1196174,8.2608841 C21.4494985,8.2302079 21.7833367,8.21505025 22.1204125,8.2099977 L22.469,8.2099977 C25.849831,8.25691424 28.9079757,9.6413131 31.1340432,11.8680443 C31.5794006,12.3133906 39.262715,23.7834022 39.262715,23.7834022 L43.9234988,16.7152448 L44.0584011,16.5106165 C44.0584011,16.5106165 38.669145,8.37528828 38.542157,8.2099977 C35.067434,3.68976942 29.7627166,0.662569829 23.7388801,0.241764545 L23.7018269,0.185103799 L3.59739413e-05,0.185103799 L23.5370663,35.8795691 C23.8187423,36.381937 24.1385506,36.8586813 24.4839004,37.3152153 C25.4537579,38.5974805 26.6610434,39.6837788 28.0442414,40.5123971 C28.0888491,40.5391035 28.1327373,40.5672534 28.1777047,40.5935988 C29.2641178,41.2258894 30.4512578,41.7011901 31.7132237,41.9823284 C32.5899086,42.1779343 33.4982506,42.2894513 34.4335731,42.2894513 C35.3685359,42.2894513 36.2765181,42.1779343 37.1532031,41.9826893 C40.0836403,41.3291058 42.618724,39.6429975 44.3756913,37.3253204 C44.7275164,36.8608466 62.2878361,10.1328541 62.4162631,9.96648082 C63.2339508,8.9054452 64.500953,8.2099977 65.9413496,8.2099977 L87.2760553,8.2099977 L92.567822,0.185103799 L65.9413496,0.185103799 Z",
  id: "Fill-1",
  fill: "#FFFFFF",
  mask: "url(#mask-3)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M75.2728101,11.8679 L46.283929,55.8297816 L39.2578585,45.1746743 L39.2287196,45.130284 L39.1844717,45.1974107 C37.6825596,45.6618845 36.0874751,45.9137902 34.433753,45.9137902 C32.7789517,45.9137902 31.1835074,45.6618845 29.6815953,45.1974107 L46.283929,70.3746311 L84.8641824,11.8679 L75.2728101,11.8679 Z",
  id: "Fill-4",
  fill: "#FFFFFF"
}))))));

var SvgVirdeeSquareLogo = function SvgVirdeeSquareLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "153px",
    height: "153px",
    viewBox: "0 0 153 153",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVirdeeSquareLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/virdee_square_logo.aaccafe4.svg";
export { ForwardRef as ReactComponent };